import gelaender_1 from './gelaender_1.jpg';
import gelaender_2 from './gelaender_2.jpg';
import gelaender_3 from './gelaender_3.jpg';
import gelaender_4 from './gelaender_4.jpg';
import gelaender_5 from './gelaender_5.jpg';

export const portfolio_treppengelaender = [
    {product_img: gelaender_1},
    {product_img: gelaender_2},
    {product_img: gelaender_3},
    {product_img: gelaender_4},
    {product_img: gelaender_5}
]